// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"af07953f","823":"5350ffd0"}[chunkId] + ".chunk.js";
};